import axios from "axios";
import { compress } from "../helpers/common.helper";
import Langs from "../constants/langComponents";
const apiUri = import.meta.env.GATEWAY_URI;

export default function useLangs() {
  const prepareLangs = (langs) => {
    const result = {};
    for (const lang of langs) {
      const componentKey = {};
      for (const component of lang.components) {
        const keyValue = {};
        for (const key of component.keys) {
          keyValue[key.key] = key.value;
        }
        componentKey[component.component] = keyValue;
      }
      result[lang.language] = componentKey;
    }

    return result;
  };

  const queryLangs = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/languages/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const getLangs = async (lang) => {
    const result = await axios.get(`${apiUri}/api/v1/languages/${lang}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return prepareLangs([result.data?.data]);
  };

  return {
    queryLangs,
    getLangs,
  };
}
